import React from "react";
import SectionItem from "./item";
import { deepEqual } from "../../utils/object";

class Section extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data ?? {}
        }
        this.sections = {};
        this.generateRefs();
    }

    generateRefs = () => {
        this.props.items?.forEach((item) => {
            this.sections[item.key] = React.createRef();
        });
    }

    componentDidUpdate = (oldProps) => {
        if (!deepEqual(this.props.items, oldProps?.items)) {
            this.generateRefs();
        }
        
        if (!deepEqual(this.state.data, this.props.data ?? {})) {
            this.setState({
                data: this.props.data ?? {}
            });
        }
    }

    onChange = () => {
        // Just notify parent that something changed
        if (this.props.onChange) {
            this.props.onChange();
        }
    }

    data = (key) => {
        try {
            if (Object.prototype.hasOwnProperty.call(this.state.data, key)) {
                return this.state.data[key];
            }
            return {};
        } catch (error) {
            return {};
        }
    } 

    getData = () => {
        const result = { ...(this.state.data ?? {}) };
        this.props.items?.forEach((item) => {
            if (this.sections[item.key].current) {
                const data = this.sections[item.key].current.getData();
                if (typeof data !== "undefined") {
                    result[item.key] = data;
                }
            }
        });
        return result;
    }
    
    render() {
        if (!this.props.items) return null;

        return (
            <>
                {this.props.items.map((item) => (
                    <SectionItem 
                        ref={this.sections[item.key]}
                        {...item} 
                        element={item.key} 
                        key={item.key} 
                        data={this.data(item.key)} 
                        active={item.index === this.props.selectedIndex} 
                        onChange={(e) => this.onChange(e, item.key)} 
                        allowDynamicDisplay={this.props.allowDynamicDisplay}
                        collectionSections={this.props.collectionSections}
                        richTextLabels={this.props.richTextLabels}
                        validationErrors={this.props.validationErrors}
                    />
                ))}
            </>
        );
    }
}

export default Section;
